import React, { Component } from 'react';
import classSet from 'react-classset';
import CircleMeter from '../CircleMeter/CircleMeter';
import { getComponentContent } from '../../helpers';
const playIcon = process.env.REACT_APP_IMAGES_ROOT + 'ssc-play.png';

class Visualizer extends Component {

  constructor() {
    super();
    this.getMinsSecs = this.getMinsSecs.bind(this);
    this.renderTitle = this.renderTitle.bind(this);
    this.renderCountdown = this.renderCountdown.bind(this);
    this.getCountdownProgress = this.getCountdownProgress.bind(this);
    this.getAudioProgress = this.getAudioProgress.bind(this);
    const content = getComponentContent('Visualizer');
    this.content = {
      4: content.countdown4,
      3: content.countdown3,
      2: content.countdown2,
      1: content.countdown1,
      0: content.countdown4
    };
    this.wasPaused = false;
    this.animationCircleStyleOverrides = [{},{},{},{},];
  }

  getMinsSecs(duration, elapsed) {
    const total = duration - elapsed;
    let mins = Math.floor(total / 60);
    if (mins < 10) {
      mins = '0' + mins;
    }
    let secs = total % 60;
    if (secs < 10) {
      secs = '0' + secs;
    }
    return mins + ':' + secs;
  }

  renderTitle(key, idx) {
    const showing = String(Math.floor(this.props.countdown)) === key;
    const textClass = showing ? 'showing' : '';
    return (
      <span key={idx} className={textClass}>{this.content[key]}</span>
    );
  }

  renderCountdown(num, idx) {
    const textClass = Math.floor(this.props.countdown) === num ? 'showing' : '';
    return (
      <span key={idx} className={textClass}>{num}</span>
    );
  }

  getCountdownProgress() {
    let elapsed = Math.min(3 - (this.props.countdown - 1), 3);
    return elapsed / 3;
  }

  getAudioProgress() {
    if (!this.props.duration) {
      return 0;
    } else {
      return this.props.currentTime / this.props.duration;
    }
  }

  render() {

    const circleClasses = classSet({
      "ssc__visualizer__circle": true,
      "ssc__control-disabled": !this.props.loaded
    });

    const playClasses = classSet({
      "ssc__visualizer__play": true,
      "ssc__visualizer__play--showing": this.props.countdown >= 4 && this.props.loaded
    });

    const countdownClasses = classSet({
      "ssc__visualizer__countdown": true,
      "ssc__visualizer__countdown--showing": this.props.countdown < 4 && this.props.countdown > 1
    });

    const timerClasses = classSet({
      "ssc__visualizer__timer": true,
      "ssc__visualizer__timer--showing": this.props.countdown < 1
    });

    const animationClasses = classSet({
      "ssc__visualizer__animation__circle": true,
      "ssc__visualizer__animation__circle--animate": this.props.countdown < 1,
      "ssc__visualizer__animation__circle--animate--paused": this.props.countdown < 1 && this.props.paused
    });

    if(!this.wasPaused && this.props.paused) {
      this.wasPaused = true;
      if(this.animationCircle1){
        let width = window.getComputedStyle(this.animationCircle1).width;
        this.animationCircleStyleOverrides[0] = {width: width, height: width};
      }
      if(this.animationCircle2){
        let width = window.getComputedStyle(this.animationCircle2).width;
        this.animationCircleStyleOverrides[1] = {width: width, height: width};
      }
      if(this.animationCircle3){
        let width = window.getComputedStyle(this.animationCircle3).width;
        this.animationCircleStyleOverrides[2] = {width: width, height: width};
      }
      if(this.animationCircle4){
        let width = window.getComputedStyle(this.animationCircle4).width;
        this.animationCircleStyleOverrides[3] = {width: width, height: width};
      }
    }

    if(!this.props.paused && this.wasPaused) {
      this.wasPaused = false;
      this.animationCircleStyleOverrides = [{},{},{},{},];
    }

    return (

      <div className="ssc__visualizer ssc__clearfix">

        <h2 className="ssc__visualizer__title">
          {Object.keys(this.content).map(this.renderTitle)}
        </h2>

        <div className={circleClasses} onClick={this.props.togglePlayPause}>

          <div className="ssc__visualizer__animation">
            <div ref={(el)=>{this.animationCircle1 = el;}} className={animationClasses} style={this.animationCircleStyleOverrides[0]}></div>
            <div ref={(el)=>{this.animationCircle2 = el;}} className={animationClasses} style={this.animationCircleStyleOverrides[1]}></div>
            <div ref={(el)=>{this.animationCircle3 = el;}} className={animationClasses} style={this.animationCircleStyleOverrides[2]}></div>
            <div ref={(el)=>{this.animationCircle4 = el;}} className={animationClasses} style={this.animationCircleStyleOverrides[3]}></div>
            <div className="ssc__visualizer__animation__circle__base"></div>
          </div>

          <img className={playClasses}  src={playIcon} alt="play" />

          <div className={countdownClasses} data-text={this.props.countdown}>
            {[3,2,1].map(this.renderCountdown)}
          </div>

          <div className={timerClasses}>{this.getMinsSecs(this.props.duration, this.props.currentTime)}</div>

          <CircleMeter
            showing={this.props.countdown < 4 && this.props.countdown > 1}
            progress={this.getCountdownProgress()}
            transitionDuration={this.props.countdown < 4 && this.props.countdown > 1 ? ".1s" : "0s"}
          />

          <CircleMeter
            showing={this.props.countdown < 1}
            progress={this.getAudioProgress()}
            transitionDuration={this.props.countdown < 1 ? "1s" : "0s"}
          />

        </div>

      </div>

    );

  }

}

export default Visualizer;



// WEBPACK FOOTER //
// ./src/components/Visualizer/Visualizer.js